module.exports = __webpack_public_path__ + "static/media/Hamburger.3f367846.svg";